export default __webpack_public_path__ + "static/media/Martial Cloak.17b5c7a6.jpg";